<!--
 * @Description: 
 * @Date: 2020-07-20 09:56:54
 * @LastEditors: jml
--> 
<template>
  <van-button
    type="info"
    @click="sendMsg"
    :disabled="!isPhone || !codeLengthRight"
  >{{time==0?'获取验证码':`${time}s后重发`}}</van-button>
</template>

<script>
import { setInterval, setTimeout } from 'timers';
export default {
  data() {
    return {
      time: 0
    };
  },
  props: {
    phone: {
      type: String | Number
    },
    imgCode: {
      type: String | Number
    },
    getMsgCodeFn: {
      type: Function
    }
  },
  computed: {
    isPhone() {
      return /^1\d{10}$/.test(this.phone);
    },
    codeLengthRight() {
      return this.imgCode && `${this.imgCode}`.length >= 4;
    }
  },
  methods: {
    sendMsg() {
      if (this.time != 0) {
        this.$toast('短信验证码已发送，请稍后再试');
        return;
      }
      if (!this.codeLengthRight) {
        this.$toast('请输入有效的图形验证码');
        return;
      }
      try {
        this.getMsgCodeFn({
          phone: this.phone,
          imgVerifyCode: this.imgCode
        })
          .then(res => {
            console.log(res);
            this.time = 60;
            this.$toast.success('验证码发送成功，请注意查收');
            this.countDown(this.time);
          })
          .catch(err => {
            this.$emit('error');
          });
      } catch (error) {
        console.warn('请传入获取短信验证码的接口');
      }
    },
    countDown(nowTime) {
      if (nowTime > 0) {
        setTimeout(() => {
          this.time = --nowTime;
          this.countDown(this.time);
        }, 1000);
      }
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  filters: {}
};
</script>
<style lang="scss" scoped>
</style>
